import { render, staticRenderFns } from "./ScrollGroup.vue?vue&type=template&id=647f6ef3"
import script from "./ScrollGroup.vue?vue&type=script&lang=js"
export * from "./ScrollGroup.vue?vue&type=script&lang=js"
import style0 from "./ScrollGroup.vue?vue&type=style&index=0&id=647f6ef3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports